module.exports = __webpack_public_path__ + "static/media/new_law_icon_blue.f31536a1.svg";